import { createAction } from "redux-actions";

import {
  REQUEST_AND_RESET_PRODUCTS_SUCCESS,
  REQUEST_AND_RESET_PRODUCTS_FAILURE,
  REQUEST_PRODUCTS_SUCCESS,
  REQUEST_PRODUCTS_FAILURE,
  REQUEST_PRODUCTS_DETAILS_SUCCESS,
  REQUEST_PRODUCTS_DETAILS_FAILURE,
  REQUEST_PRODUCT_MAPPING_SUCCESS,
  REQUEST_PRODUCT_MAPPING_FAILURE,
  REQUEST_PRODUCT_MAPPING_IMAGES_SUCCESS,
  REQUEST_PRODUCT_MAPPING_IMAGES_FAILURE,
  SAVE_PRODUCT_MAPPING_SUCCESS,
  SAVE_PRODUCT_MAPPING_FAILURE,
  BULK_IGNORE_PRODUCTS_SUCCESS,
  BULK_IGNORE_PRODUCTS_FAILURE,
  SET_BULK_IGNORE_JOB,
  CLEAR_BULK_IGNORE_JOB,
  SET_MOVE_ALL_TO_APP_LOCATION_JOB,
  CLEAR_MOVE_ALL_TO_APP_LOCATION_JOB,
  SET_PRODUCT_CREATE_JOB,
  CLEAR_PRODUCT_CREATE_JOB,
  PATCH_MANUAL_PRODUCT,
  POST_MANUAL_PRODUCT_SUCCESS,
  POST_MANUAL_PRODUCT_FAILURE,
  POST_MANUAL_CSV_PRODUCT_SUCCESS,
  POST_MANUAL_CSV_PRODUCT_FAILURE,
  REQUEST_MANUAL_PRODUCT_SUCCESS,
  REQUEST_MANUAL_PRODUCT_FAILURE,
  UPDATE_MANUAL_PRODUCT_NAME_SUCCESS,
  UPDATE_MANUAL_PRODUCT_NAME_FAILURE,
  SET_DISCOUNT_PRICE_AND_PLACEMENT_SUCCESS,
  SET_DISCOUNT_PRICE_AND_PLACEMENT_FAILURE,
  REQUEST_BLANK_PRODUCT_COLORS_SUCCESS,
  REQUEST_BLANK_PRODUCT_COLORS_FAILURE,
  GET_LISTING_MAPPING_TO_DRAFT_SUCCESS,
  GET_LISTING_MAPPING_TO_DRAFT_FAILURE,
  SAVE_LISTING_MAPPING_TO_DRAFT_SUCCESS,
  SAVE_LISTING_MAPPING_TO_DRAFT_FAILURE,
  REQUEST_PRODUCTS_COUNT_SUCCESS,
  REQUEST_PRODUCTS_COUNT_FAILURE,
  SAVE_LISTING_TEMPLATE_SUCCESS,
  SAVE_LISTING_TEMPLATE_FAILURE,
  GET_LISTING_TEMPLATE_SUCCESS,
  GET_LISTING_TEMPLATE_FAILURE,
  DELETE_LISTING_TEMPLATE_SUCCESS,
  DELETE_LISTING_TEMPLATE_FAILURE,
  IMPORT_PRODUCT_SUCCESS,
  IMPORT_PRODUCT_FAILURE,
  DELETE_PRODUCTS_SUCCESS,
  DELETE_PRODUCTS_FAILURE,
  SYNC_LISTINGS_SUCCESS,
  SYNC_LISTINGS_FAILURE,
  REMOVE_LISTINGS_SUCCESS,
  UPDATE_PREVIEW_IMAGES,
  UPDATE_CANVAS_IMAGES,
  SET_SELECTED_FILTER_FOR_LISTING,
  SET_LISTING_LAST_ID,
  REQUEST_MANUAL_PRODUCT_DETAILS_SUCCESS,
  REQUEST_MANUAL_PRODUCT_DETAILS_FAILURE,
  GET_ALL_VARIANTS_COST_SUCCESS,
  GET_ALL_VARIANTS_COST_FAILURE,
  GET_SINGLE_VARIANT_COST_SUCCESS,
  GET_SINGLE_VARIANT_COST_FAILURE,
  GET_MULTIPLE_BLANK_VARIANT_COSTS_SUCCESS,
  GET_MULTIPLE_BLANK_VARIANT_COSTS_FAILURE,
} from "../constants/actionTypes";
import * as Products from "../api/products";
import * as ProductCreateJobs from "../api/productCreateJobs";

const requestProductsSuccess = createAction(REQUEST_PRODUCTS_SUCCESS);
const requestProductsFailure = createAction(REQUEST_PRODUCTS_FAILURE);

// A newer listings reload (store filter, status, clear) invalidates an
// in-flight page so it cannot append or replace the list the user just asked for.
let listingsFetchGeneration = 0;

export function requestProducts(query) {
  const generation = listingsFetchGeneration;
  return (dispatch) =>
    Products.requestProducts(query)
      .then((data) => {
        if (generation !== listingsFetchGeneration) return data;
        return dispatch(requestProductsSuccess(data));
      })
      .catch((error) => {
        if (generation !== listingsFetchGeneration) return { error };
        return dispatch(requestProductsFailure(error));
      });
}

const deleteProductsSuccess = createAction(DELETE_PRODUCTS_SUCCESS);
const deleteProductsFailure = createAction(DELETE_PRODUCTS_FAILURE);

export function deleteProducts(id) {
  return (dispatch) =>
    Products.deleteProducts(id)
      .then(({ data }) => dispatch(deleteProductsSuccess({ id, data })))
      .catch((error) => dispatch(deleteProductsFailure(error)));
}

export const setSelectedFilterForListing = createAction(
  SET_SELECTED_FILTER_FOR_LISTING
);

export const setListingLastId = createAction(SET_LISTING_LAST_ID);

const requestAndResetProductsSuccess = createAction(
  REQUEST_AND_RESET_PRODUCTS_SUCCESS
);
const requestAndResetProductsFailure = createAction(
  REQUEST_AND_RESET_PRODUCTS_FAILURE
);

export function requestAndResetProducts(query) {
  const generation = ++listingsFetchGeneration;
  return (dispatch) =>
    Products.requestProducts(query)
      .then((data) => {
        if (generation !== listingsFetchGeneration) return data;
        return dispatch(requestAndResetProductsSuccess(data));
      })
      .catch((error) => {
        if (generation !== listingsFetchGeneration) return { error: true };
        return dispatch(requestAndResetProductsFailure(error));
      });
}
const importProductSuccess = createAction(IMPORT_PRODUCT_SUCCESS);
const importProductFailure = createAction(IMPORT_PRODUCT_FAILURE);

export function requestImportProduct(id, shopId) {
  return (dispatch) =>
    Products.requestImportProduct(id, shopId)
      .then((data) => dispatch(importProductSuccess(data)))
      .catch((error) => dispatch(importProductFailure(error)));
}

const requestProductsCountSuccess = createAction(
  REQUEST_PRODUCTS_COUNT_SUCCESS
);
const requestProductsCountFailure = createAction(
  REQUEST_PRODUCTS_COUNT_FAILURE
);

export function requestProductsCount(query) {
  return (dispatch) =>
    Products.requestProductsCount(query)
      .then((data) => dispatch(requestProductsCountSuccess(data)))
      .catch((error) => dispatch(requestProductsCountFailure(error)));
}

const requestProductDetailsSuccess = createAction(
  REQUEST_PRODUCTS_DETAILS_SUCCESS
);
const requestProductDetailsFailure = createAction(
  REQUEST_PRODUCTS_DETAILS_FAILURE
);

export function requestProductDetails(id, query) {
  return (dispatch) =>
    Products.requestProductDetails(id, query)
      .then((data) => dispatch(requestProductDetailsSuccess(data)))
      .catch((error) => dispatch(requestProductDetailsFailure(error)));
}

const requestProductMappingSuccess = createAction(
  REQUEST_PRODUCT_MAPPING_SUCCESS
);
const requestProductMappingFailure = createAction(
  REQUEST_PRODUCT_MAPPING_FAILURE
);

export function requestProductMapping(id, query) {
  return (dispatch) =>
    Products.requestProductMapping(id, query)
      .then((data) => dispatch(requestProductMappingSuccess(data)))
      .catch((error) => dispatch(requestProductMappingFailure(error)));
}

const requestProductMappingImagesSuccess = createAction(
  REQUEST_PRODUCT_MAPPING_IMAGES_SUCCESS
);
const requestProductMappingImagesFailure = createAction(
  REQUEST_PRODUCT_MAPPING_IMAGES_FAILURE
);

export function requestProductMappingImages(id, query) {
  return (dispatch) =>
    Products.requestProductMappingImages(id, query)
      .then((data) => dispatch(requestProductMappingImagesSuccess(data)))
      .catch((error) => dispatch(requestProductMappingImagesFailure(error)));
}

const saveProductMappingSuccess = createAction(SAVE_PRODUCT_MAPPING_SUCCESS);
const saveProductMappingFailure = createAction(SAVE_PRODUCT_MAPPING_FAILURE);

export function saveProductMapping(id, data) {
  return (dispatch) =>
    Products.saveProductMapping(id, data)
      .then((data) => dispatch(saveProductMappingSuccess(data)))
      .catch((error) => dispatch(saveProductMappingFailure(error)));
}

const bulkIgnoreProductsSuccess = createAction(BULK_IGNORE_PRODUCTS_SUCCESS);
const bulkIgnoreProductsFailure = createAction(BULK_IGNORE_PRODUCTS_FAILURE);

/** Starts an async bulk-ignore job. Does not update the product list yet. */
export function bulkIgnoreProducts(data) {
  return (dispatch) =>
    Products.bulkIgnoreProducts(data)
      .then((res) => dispatch(bulkIgnoreProductsSuccess(res)))
      .catch((error) => dispatch(bulkIgnoreProductsFailure(error)));
}

export function getBulkIgnoreStatus(jobId) {
  return Products.getBulkIgnoreStatus(jobId);
}

/** Apply ignored flags to products already in the list (after a job finishes). */
export const markProductsIgnored = createAction(
  BULK_IGNORE_PRODUCTS_SUCCESS,
  (productIds, ignored = true) => ({
    data: { productIds, ignored },
  })
);

export const setBulkIgnoreJob = createAction(SET_BULK_IGNORE_JOB);
export const clearBulkIgnoreJob = createAction(CLEAR_BULK_IGNORE_JOB);

export const setMoveAllToAppLocationJob = createAction(
  SET_MOVE_ALL_TO_APP_LOCATION_JOB
);
export const clearMoveAllToAppLocationJob = createAction(
  CLEAR_MOVE_ALL_TO_APP_LOCATION_JOB
);

export function startMoveAllToAppLocation(data) {
  return (dispatch) =>
    Products.startMoveAllToAppLocation(data)
      .then((res) => {
        dispatch(setMoveAllToAppLocationJob(res?.data || res));
        return res;
      })
      .catch((error) => {
        dispatch(
          setMoveAllToAppLocationJob({
            status: "failed",
            error:
              error?.response?.data?.message ||
              error?.message ||
              "Could not start product move.",
          })
        );
        throw error;
      });
}

export function getMoveAllToAppLocationStatus(jobId, query) {
  return Products.getMoveAllToAppLocationStatus(jobId, query);
}

export const setProductCreateJob = createAction(SET_PRODUCT_CREATE_JOB);
export const clearProductCreateJob = createAction(CLEAR_PRODUCT_CREATE_JOB);

export function enqueueProductCreateJob(data) {
  return ProductCreateJobs.enqueueProductCreateJob(data);
}

export function getProductCreateJobStatus(jobId) {
  return ProductCreateJobs.getProductCreateJob(jobId);
}

export function getProductCreateUploadUrl(jobId, data) {
  return ProductCreateJobs.getProductCreateUploadUrl(jobId, data);
}

export function completeProductCreateUpload(jobId, data) {
  return ProductCreateJobs.completeProductCreateUpload(jobId, data);
}

export function failProductCreateJob(jobId, data) {
  return ProductCreateJobs.failProductCreateJob(jobId, data);
}

export const patchManualProduct = createAction(PATCH_MANUAL_PRODUCT);

const postManualProductSuccess = createAction(POST_MANUAL_PRODUCT_SUCCESS);
const postManualProductFailure = createAction(POST_MANUAL_PRODUCT_FAILURE);

export function postManualProduct(id, data) {
  return (dispatch) =>
    Products.postManualProduct(id, data)
      .then((data) => dispatch(postManualProductSuccess(data)))
      .catch((error) => dispatch(postManualProductFailure(error)));
}

const postManualCsvProductSuccess = createAction(
  POST_MANUAL_CSV_PRODUCT_SUCCESS
);
const postManualCsvProductFailure = createAction(
  POST_MANUAL_CSV_PRODUCT_FAILURE
);

export function postManualCsvProduct(id, data) {
  return (dispatch) =>
    Products.postManualCsvProduct(id, data)
      .then((data) => dispatch(postManualCsvProductSuccess(data)))
      .catch((error) => dispatch(postManualCsvProductFailure(error)));
}

const requestManualProductsSuccess = createAction(
  REQUEST_MANUAL_PRODUCT_SUCCESS
);
const requestManualProductsFailure = createAction(
  REQUEST_MANUAL_PRODUCT_FAILURE
);

export function requestManualProducts(query = {}) {
  return (dispatch) =>
    Products.requestManualProducts(query)
      .then((data) =>
        dispatch(
          requestManualProductsSuccess({
            ...data,
            meta: { reset: !query?.startAfter },
          })
        )
      )
      .catch((error) => dispatch(requestManualProductsFailure(error)));
}

const updateManualProductNameSuccess = createAction(
  UPDATE_MANUAL_PRODUCT_NAME_SUCCESS
);
const updateManualProductNameFailure = createAction(
  UPDATE_MANUAL_PRODUCT_NAME_FAILURE
);

export function updateManualProductName(id, name) {
  return (dispatch) =>
    Products.updateManualProductName(id, { name })
      .then((data) => dispatch(updateManualProductNameSuccess(data)))
      .catch((error) => dispatch(updateManualProductNameFailure(error)));
}

const setDiscountPriceAndPlacementsSuccess = createAction(
  SET_DISCOUNT_PRICE_AND_PLACEMENT_SUCCESS
);
const setDiscountPriceAndPlacementsFailure = createAction(
  SET_DISCOUNT_PRICE_AND_PLACEMENT_FAILURE
);

export function setDiscountPriceAndPlacements(id, data) {
  return (dispatch) =>
    Products.setDiscountPriceAndPlacements(id, data)
      .then((data) => dispatch(setDiscountPriceAndPlacementsSuccess(data)))
      .catch((error) => dispatch(setDiscountPriceAndPlacementsFailure(error)));
}

const requestBlankProductColorsSuccess = createAction(
  REQUEST_BLANK_PRODUCT_COLORS_SUCCESS
);
const requestBlankProductColorsFailure = createAction(
  REQUEST_BLANK_PRODUCT_COLORS_FAILURE
);

export function requestBlankProductColors() {
  return (dispatch) =>
    Products.requestBlankProductColors()
      .then(({ data }) => dispatch(requestBlankProductColorsSuccess(data)))
      .catch((error) => dispatch(requestBlankProductColorsFailure(error)));
}

const saveListingMappingToDraftSuccess = createAction(
  SAVE_LISTING_MAPPING_TO_DRAFT_SUCCESS
);
const saveListingMappingToDraftFailure = createAction(
  SAVE_LISTING_MAPPING_TO_DRAFT_FAILURE
);

export function saveListingMappingToDraft(id, data) {
  return (dispatch) =>
    Products.saveListingMappingToDraft(id, data)
      .then(({ data }) => dispatch(saveListingMappingToDraftSuccess(data)))
      .catch((error) => dispatch(saveListingMappingToDraftFailure(error)));
}

const getListingMappingToDraftSuccess = createAction(
  GET_LISTING_MAPPING_TO_DRAFT_SUCCESS
);
const getListingMappingToDraftFailure = createAction(
  GET_LISTING_MAPPING_TO_DRAFT_FAILURE
);

export function getListingMappingToDraft(id, data) {
  return (dispatch) =>
    Products.getListingMappingToDraft(id, data)
      .then(({ data }) => dispatch(getListingMappingToDraftSuccess(data)))
      .catch((error) => dispatch(getListingMappingToDraftFailure(error)));
}

const saveListingTemplateSuccess = createAction(SAVE_LISTING_TEMPLATE_SUCCESS);
const saveListingTemplateFailure = createAction(SAVE_LISTING_TEMPLATE_FAILURE);

export function saveListingTemplate(params) {
  return (dispatch) =>
    Products.saveListingTemplate(params)
      .then(({ data }) =>
        dispatch(saveListingTemplateSuccess({ data, params }))
      )
      .catch((error) => dispatch(saveListingTemplateFailure(error)));
}

const getListingTemplateSuccess = createAction(GET_LISTING_TEMPLATE_SUCCESS);
const getListingTemplateFailure = createAction(GET_LISTING_TEMPLATE_FAILURE);

export function getListingTemplate(query) {
  return (dispatch) =>
    Products.getListingTemplate(query)
      .then(({ data }) => dispatch(getListingTemplateSuccess(data)))
      .catch((error) => dispatch(getListingTemplateFailure(error)));
}

const deleteListingTemplateSuccess = createAction(
  DELETE_LISTING_TEMPLATE_SUCCESS
);
const deleteListingTemplateFailure = createAction(
  DELETE_LISTING_TEMPLATE_FAILURE
);

export function deleteListingTemplate(id) {
  return (dispatch) =>
    Products.deleteListingTemplate(id)
      .then(({ data }) => dispatch(deleteListingTemplateSuccess({ id, data })))
      .catch((error) => dispatch(deleteListingTemplateFailure(error)));
}

const requestManualProductDetailsSuccess = createAction(
  REQUEST_MANUAL_PRODUCT_DETAILS_SUCCESS
);
const requestManualProductDetailsFailure = createAction(
  REQUEST_MANUAL_PRODUCT_DETAILS_FAILURE
);

export function requestManualProductDetails(id) {
  return (dispatch) =>
    Products.requestManualProductDetails(id)
      .then(({ data }) =>
        dispatch(requestManualProductDetailsSuccess({ id, data }))
      )
      .catch((error) => dispatch(requestManualProductDetailsFailure(error)));
}

const handleProductSyncSuccess = createAction(SYNC_LISTINGS_SUCCESS);
const handleProductSyncFailure = createAction(SYNC_LISTINGS_FAILURE);

export function syncListings(id) {
  return (dispatch) =>
    Products.syncListings(id)
      .then(({ data }) => dispatch(handleProductSyncSuccess({ id, data })))
      .catch((error) => dispatch(handleProductSyncFailure(error)));
}

const removeListingsSuccess = createAction(REMOVE_LISTINGS_SUCCESS);

// Resolves to { removed: [...ids], skipped: [...ids] }; rejects on failure.
export function removeListings(listingIds) {
  return (dispatch) =>
    Products.removeListings(listingIds).then(({ data }) => {
      const removed = data?.removed || [];
      dispatch(removeListingsSuccess({ ids: removed }));
      return data || { removed, skipped: [] };
    });
}

// preview
export const updatePreviewImage = createAction(UPDATE_PREVIEW_IMAGES);

// Print files
export const updateCanvasImages = createAction(UPDATE_CANVAS_IMAGES);

const getAllVariantsCostSuccess = createAction(GET_ALL_VARIANTS_COST_SUCCESS);
const getAllVariantsCostFailure = createAction(GET_ALL_VARIANTS_COST_FAILURE);

export function getAllVariantsCost(id, query) {
  return (dispatch) =>
    Products.getAllVariantsCost(id, query)
      .then(({ data }) => {
        const action = getAllVariantsCostSuccess({ id, data });
        dispatch(action);
        // Return the action so callers can read `res.payload.data`.
        return action;
      })
      .catch((error) => {
        dispatch(getAllVariantsCostFailure(error));
        // Re-throw so await/dispatch().catch actually sees failures.
        throw error;
      });
}

const getSingleVariantCostSuccess = createAction(
  GET_SINGLE_VARIANT_COST_SUCCESS
);
const getSingleVariantCostFailure = createAction(
  GET_SINGLE_VARIANT_COST_FAILURE
);

export function getSingleVariantCost(data) {
  return (dispatch) =>
    Products.getSingleVariantCost(data)
      .then(({ data }) => dispatch(getSingleVariantCostSuccess(data)))
      .catch((error) => dispatch(getSingleVariantCostFailure(error)));
}

const getMultipleBlankVariantCostsSuccess = createAction(
  GET_MULTIPLE_BLANK_VARIANT_COSTS_SUCCESS
);
const getMultipleBlankVariantCostsFailure = createAction(
  GET_MULTIPLE_BLANK_VARIANT_COSTS_FAILURE
);

export function getMultipleBlankVariantCosts(data) {
  return (dispatch) =>
    Products.getMultipleBlankVariantCosts(data)
      .then(({ data }) => dispatch(getMultipleBlankVariantCostsSuccess(data)))
      .catch((error) => dispatch(getMultipleBlankVariantCostsFailure(error)));
}
